import { PrivateLayout } from '@features/auth/private-layout';
import {
  HomePage,
  InvoiceDetailPage,
  InvoiceItemPage,
  InvoicesPage,
  ItemCatalogCreatePage,
  ItemCatalogDetailPage,
  ItemCatalogPage,
  ListCreatePage,
  ListDetailPage,
  ListPurchasePage,
  LoginPage,
  ProfilePage,
  QRCodePage,
} from '@features/shared/routes';
import { createBrowserRouter } from 'react-router-dom';

import { ErrorPage } from './error';
import { Layout } from './layout';

export const router = createBrowserRouter([
  {
    errorElement: <ErrorPage />,
    element: <Layout />,
    children: [
      {
        path: '/login',
        element: <LoginPage />,
      },
      {
        path: '/',
        element: <PrivateLayout />,
        children: [
          {
            index: true,
            element: <HomePage />,
          },
          {
            path: 'profile',
            element: <ProfilePage />,
          },
          {
            path: 'qrcode',
            element: <QRCodePage />,
          },
          {
            path: 'item-catalog',
            element: <ItemCatalogPage />,
          },
          {
            path: 'item-catalog/new',
            element: <ItemCatalogCreatePage />,
          },
          {
            path: 'item-catalog/:itemCatalogId',
            element: <ItemCatalogDetailPage />,
          },
          {
            path: 'list/new',
            element: <ListCreatePage />,
          },
          {
            path: 'list/:listId',
            element: <ListDetailPage />,
          },
          {
            path: 'list/:listId/purchase',
            element: <ListPurchasePage />,
          },
          {
            path: 'merchant/:merchantId',
            element: <InvoicesPage />,
          },
          {
            path: 'merchant/:merchantId/invoices/:invoiceId',
            element: <InvoiceDetailPage />,
          },
          {
            path: 'merchant/:merchantId/invoices/:invoiceId/item/:invoiceItemId',
            element: <InvoiceItemPage />,
          },
        ],
      },
    ],
  },
]);
